import { DataLayer } from "@allwyn/utils/data-layer";
import { useNgCasinoGameList } from "./ng-casino-game-list";
import { useNgCasinoState } from "./use-ng-casino-state";
import { CasinoGameType } from "../model/casino-game-type";

export interface PushGameDetailParams {
    analyticsGameCode: string;
    moneyMode: boolean;
    gameId: number;
    placement?: string;
    position?: number;
    url?: string;
}

export namespace NgCasinoAnalytics {
    export const gameVerticalMapping: Record<string, string> = {
        [CasinoGameType.game]: "hry",
        [CasinoGameType.eticket]: "elosy",
        [CasinoGameType.livedealer]: "hry-live",
        [CasinoGameType.funpark]: "funpark",
        [CasinoGameType.underground]: "stiraci-hry",
    };

    export function resolveGameVertical(gameUrl: string): CasinoGameType {
        const currentUrl = window.location.href.toLowerCase();

        // underground is just eticket used on different pages
        if (currentUrl.includes("stiraci-hry") || (gameUrl.includes("losy") && currentUrl.includes("hry")))
            return CasinoGameType.underground;

        const urlToMatch = gameUrl || currentUrl;
        if (urlToMatch.includes("hry-live")) return CasinoGameType.livedealer;
        if (urlToMatch.includes("losy")) return CasinoGameType.eticket;
        if (urlToMatch.includes("funpark")) return CasinoGameType.funpark;
        return CasinoGameType.game;
    }

    export const pushGameDetail = (params: PushGameDetailParams): void => {
        const vertical = resolveGameVertical(params.url ?? "");

        const verticalCode = gameVerticalMapping[vertical] || "";
        const ngGameDefinition = useNgCasinoGameList().getNgGameDefinition(params.gameId);
        const { currentGameServerData } = useNgCasinoState();

        const page = {
            type: "game.detail",
            verticalCode: verticalCode,
            verticalCodeStrict: verticalCode,
            gameCode: params.analyticsGameCode,
            gameCodeStrict: params.analyticsGameCode,
            gameMode: params.moneyMode ? "money" : "fun",
            gameid: params.gameId,
            supplier: ngGameDefinition?.externalGameSubProvider || ngGameDefinition?.externalGameProvider || "",
        };

        if (params.placement) {
            page["placement"] = params.placement;
        }

        if (params.position) {
            page["position"] = params.position;
        }

        if (currentGameServerData.value) {
            page["eventProperty5"] = `multilayer.${page.gameCode}`;
        }

        DataLayer.pushInstant({
            page: page,
            event: "page",
        });
    };

    export const pushDepositClick = (): void => {
        DataLayer.push({
            event: "action.click.hry",
            action: {
                click: {
                    type: "inGameDeposit",
                },
            },
        });
    };

    export const pushToggleMoneyMode = (playForMoney: boolean): void => {
        DataLayer.pushInstant({
            event: "action.click.hry",
            action: {
                click: {
                    type: playForMoney ? "money" : "fun",
                },
            },
        });
    };

    // https://sazka.atlassian.net/wiki/spaces/WA/pages/1104871496/Hry+Page+sazka.cz+hry#DL3.60
    export const pushIframeDepositClick = (gameCode: string) => {
        DataLayer.push({
            event: "action.deposit.game",
            action: {
                deposit: {
                    label: gameCode,
                    eventProperty5: `multilayer.${gameCode}`,
                },
            },
        });
    };
}
